import styled from "styled-components";

export const CollapsedContainer = styled.div`
  font-family: "Plus Jakarta Sans", sans-serif;
  .card-container {
    box-shadow: none;
    .card-header {
      background-color: #eef0f8;
      border: none;
    }
    .analytics-container {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin-right: 7px;
        font-size: 15px;
        color: #00a4e5;
        text-decoration: underline;
        cursor: pointer;
      }
      .icon-button {
        background-color: #00a4e5;
        color: #fff;
      }
    }

    .collapse-content {
      background-color: #eef0f8;
    }
  }
  .collapseScroll {
    justify-content: center;
  }
  @media screen and (max-width: 992px) {
    .collapseScroll {
      justify-content: start;
      flex-wrap: nowrap;
    }
  }

  .MuiCardHeader-root {
    /* padding: 10px; */
    padding: 9px 12px 9px 0px;
  }
`;
